import { useTranslation } from 'react-i18next';

import { SVGIconType } from '../../../../constants/svgIcon';
import { SvgIcon } from '../../SVGIcon';
import { GeneralModal, GeneralModalNoButtonVariant } from '../GeneralModal';

import styles from './UnavailableAllStrokeDataModal.module.css';

type UnavailableAllStrokeDataModalProps = {
  onCancel: () => void;
};

export const UnavailableAllStrokeDataModal = (
  props: UnavailableAllStrokeDataModalProps,
) => {
  const { onCancel } = props;
  const { t } = useTranslation();

  return (
    <GeneralModal
      onClose={onCancel}
      buttonSetting={{
        noText: t('OK'),
        noVariant: GeneralModalNoButtonVariant.Cyan,
      }}
      isDisableWidthAndPadding={true}
    >
      <div className={styles.unavailableStroke}>
        <div className={styles.centerContainer}>
          <SvgIcon name={SVGIconType.WritingJoy} className={styles.titleIcon} />
          <div className={styles.warningText}>
            <div>{t('Stroke data for all characters is unavailable.')}</div>
          </div>
        </div>
      </div>
    </GeneralModal>
  );
};
